import { trpc } from '@/shared/api/trpc';

// Drives the `<ServerSearchSelect>` for the task's Itinerary field.
// Mirrors the itinerary-form Customer picker (`use-customer-search.ts`):
// - empty query  → first page of `itineraries.search` so the opened
//   dropdown shows recent itineraries instead of "No matches".
// - non-empty query → `itineraries.search({ title })` substring match.
// Legacy parity: label prefers the itinerary title, falling back to its
// reference (e.g. "PT51655") when untitled.

export type ItinerarySearchResult = {
  id: string;
  label: string;
};

const INITIAL_LIST_LIMIT = 100;

const projectRow = (row: {
  id: string;
  title: string | null;
  itineraryRef: string | null;
}): ItinerarySearchResult => ({
  id: row.id,
  label: row.title ?? row.itineraryRef ?? row.id,
});

export const useItinerarySearch = (query: string, open: boolean) => {
  const trimmed = query.trim();
  const isSearching = trimmed.length > 0;

  const listQuery = trpc.itineraries.search.useQuery(
    { limit: INITIAL_LIST_LIMIT, offset: 0 },
    {
      enabled: open && !isSearching,
      select: (page) => page.data.map(projectRow),
    }
  );

  const searchQuery = trpc.itineraries.search.useQuery(
    { title: trimmed, limit: INITIAL_LIST_LIMIT, offset: 0 },
    {
      enabled: open && isSearching,
      select: (page) => page.data.map(projectRow),
    }
  );

  return {
    data: isSearching ? searchQuery.data : listQuery.data,
    isLoading: isSearching ? searchQuery.isLoading : listQuery.isLoading,
  };
};
